var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMenuWidgets = function SvgMenuWidgets(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9524 4.61523H7.04763C5.76422 4.61523 4.72382 5.62454 4.72382 6.86958V17.9565C4.72382 19.2016 5.76422 20.2109 7.04763 20.2109H16.9524C18.2358 20.2109 19.2762 19.2016 19.2762 17.9565V6.86958C19.2762 5.62454 18.2358 4.61523 16.9524 4.61523Z",
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76662 14.4131H16.2999C16.889 14.4131 17.3666 14.83 17.3666 15.3444V17.207C17.3666 17.7213 16.889 18.1383 16.2999 18.1383H7.76662C7.17751 18.1383 6.69995 17.7213 6.69995 17.207V15.3444C6.69995 14.83 7.17751 14.4131 7.76662 14.4131ZM9.76802 16.213C9.76802 16.71 9.36507 17.113 8.86802 17.113C8.37096 17.113 7.96802 16.71 7.96802 16.213C7.96802 15.7159 8.37096 15.313 8.86802 15.313C9.36507 15.313 9.76802 15.7159 9.76802 16.213Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuWidgets, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-widgets.c19e0bd9.svg";
export { ForwardRef as ReactComponent };